<template>
  <div>
    <div>
      <div class="h-screen relative bg-videoBg">
        <div
          class="logo-overlay inset-0 absolute flex items-center justify-center pb-32 pt-32 z-20"
        >
          <div class="-mt-16">
            <p
              class="text-center w-full uppercase block text-white text-xl mb-6"
            >
              Poolsuite Presents
            </p>

            <svg
              class="h-auto mx-10 svg-width"
              viewBox="0 0 935 180"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M238.017 3.75C225.267 1.99999 212.267 0.249998 199.517 0.249998C154.017 0.249998 132.767 23 132.767 43.25C132.767 57 143.017 64 146.767 64C148.517 64 149.017 62.25 149.017 61.5C149.017 60.5 148.767 60.5 146.517 59.25C143.517 57.75 139.517 52.5 139.517 46C139.517 32 157.267 8.25 208.517 8.25C228.267 8.25 247.767 10.5 267.517 13.25C241.017 22.25 218.017 37 172.017 82.25C152.017 102 129.767 124.5 111.767 141.25C78.5166 172 60.0166 174 47.2666 174C39.2666 174 13.0166 172.75 8.0166 153.75C7.2666 151.25 7.0166 150.5 6.2666 150.5C5.5166 150.5 0.266602 152.75 0.266602 159.75C0.266602 163.75 1.5166 167.5 9.2666 172C12.2666 173.75 22.5166 179.5 43.0166 179.5C86.5166 179.5 112.267 156 160.767 107.25C207.767 60.75 216.017 52.5 232.517 39.5C245.267 29.75 255.767 22.75 269.267 17.75C275.517 15.25 278.767 15 284.267 14.75C259.767 30.5 237.267 54.25 210.517 85C179.767 120.25 172.517 130.5 168.767 136C153.767 157.75 151.767 164.25 151.767 168.75C151.767 171.75 152.517 176.25 159.267 176.25C166.517 176.25 173.767 170.75 188.267 156.25C200.517 144 212.017 131.25 223.767 118.25C249.767 89.25 293.267 40.75 322.017 18C334.517 8.25 335.267 7.74999 338.267 7.74999C339.017 7.74999 340.767 7.74999 340.767 8.99999C340.767 11 339.017 13.25 324.517 29.5C296.267 61 272.267 87.75 256.767 109C235.267 138 228.767 152.5 228.767 162.75C228.767 168.75 232.017 177.25 243.517 177.25C254.267 177.25 264.267 170.5 275.267 160.75C276.517 159.5 279.017 157.25 279.017 155C279.017 153.75 278.267 152.25 277.267 152.25C276.517 152.25 275.767 152.75 275.017 153.5C267.767 160 254.767 172 245.517 172C243.267 172 238.267 171.75 238.267 165.25C238.267 143 283.767 89.5 328.017 37.25C334.517 29.75 347.017 15 347.017 7.99999C347.017 6.49999 346.267 2.5 340.767 2.5C324.017 2.5 280.267 48.25 262.767 66.75C251.517 78.75 198.017 138.25 193.767 142.75C185.017 152 174.017 163.5 165.767 169C162.767 171 161.267 171.25 160.517 171.25C158.767 171.25 158.017 169 158.017 167.75C158.017 157.75 231.767 72 265.767 37.75C280.767 22.5 293.767 13.25 297.267 11.5C299.017 10.75 301.017 10.25 301.017 8.99999C301.017 8.5 300.517 6.99999 298.767 6.99999L291.267 7.49999C286.767 7.49999 282.517 8.5 278.017 9.5L238.017 3.75ZM380.483 88.5C380.483 87.5 378.483 87.25 377.483 87.25C376.983 87.25 372.733 87.25 370.233 89C369.733 89.5 362.483 98 362.233 99C362.733 97 363.483 94.75 363.483 92.5C363.483 87 359.483 85 354.483 85C327.483 85 271.733 137.25 271.733 163.75C271.733 170.5 274.733 177.75 284.233 177.75C296.733 177.75 310.733 164.75 320.733 155.25C318.733 159 316.733 163 316.733 167.5C316.733 168.5 316.733 177.5 326.733 177.5C341.483 177.5 362.733 159 362.733 154.5C362.733 153.5 362.233 152 361.233 152C360.483 152 356.733 155.5 355.733 156.5C346.733 164.5 334.983 172.25 328.233 172.25C322.733 172.25 322.733 167.25 322.733 167C322.733 154.25 380.483 93 380.483 88.5ZM349.983 90.25C354.233 90 355.983 92 355.983 95.75C355.983 113.25 304.483 172.25 284.983 172.25C280.233 172.25 280.233 167.75 280.233 166.75C280.233 147 331.233 91.5 349.983 90.25ZM344.954 175.75C344.954 177.25 345.704 177.5 346.704 177.5C350.954 177.5 356.704 173 359.704 169.5C362.454 166 364.954 162.25 367.704 158.75C381.454 140.5 427.954 89.75 443.954 89.75C446.204 89.75 447.954 90.75 447.954 93C447.954 97.5 443.704 102.5 423.954 123.5C411.704 136.25 398.704 150.25 398.704 165.75C398.704 173.5 403.204 177.75 409.204 177.75C419.704 177.75 431.954 169.25 440.954 161.75C442.704 160.25 446.204 157.25 446.204 154.5C446.204 153 445.204 152 444.454 152C443.954 152 443.454 152.5 439.704 155.75C432.204 162 425.704 167 418.704 170.25C415.454 171.75 412.704 172.5 410.704 172.5C408.704 172.5 404.954 171.5 404.954 167C404.954 158.5 420.954 140.25 429.204 130.75C444.704 113 453.704 102.5 453.704 92.75C453.704 85.5 447.204 85 444.954 85C438.454 85 431.454 87.75 417.454 99C410.204 104.75 408.454 106.5 391.954 123C402.954 107.5 408.954 99.25 415.454 90.25C415.954 89.75 415.704 89.25 415.704 88.75C415.704 87 414.204 87 413.454 86.75H391.704C390.454 87 387.204 87.25 387.204 90.75C387.204 92.5 388.204 92.25 389.454 92.25H404.954C392.204 111.75 372.204 137.5 359.954 153.25C355.704 158.25 345.704 171.25 344.954 174.75V175.75ZM516.925 126C516.425 120.25 516.425 118 518.925 112.25C523.925 100 524.175 99 524.175 95.25C524.175 88.25 519.425 84.75 512.675 84.75C489.675 84.75 437.175 135.75 437.175 162.25C437.175 174.5 444.175 177.75 451.675 177.75C475.425 177.75 504.175 136 511.175 125.25C512.425 126 513.425 126.5 514.425 126.5C515.175 126.5 516.175 126.25 516.925 126ZM516.425 90.75C513.675 93.75 510.925 96.5 509.675 101.75C508.175 107 508.925 113 507.175 118C504.925 124.5 472.925 172.5 452.925 172.5C447.175 172.5 445.425 168.5 445.425 165.5C445.425 148.5 491.675 89.75 512.425 89.75C513.925 89.75 514.925 90 516.425 90.75ZM558.985 110.75L539.235 127C546.735 116 549.735 111.75 564.985 91.75C565.735 90.75 566.485 89.75 566.485 88.75C566.485 88.25 565.985 86.5 563.235 86.75H542.735C537.735 86.75 537.735 91 537.735 91.25C537.735 92.25 538.985 92.25 540.985 92.25H555.735C538.485 117.75 525.235 134.75 511.485 151.75C507.735 156.5 495.235 172 494.985 174.75C494.985 176 495.235 177.5 496.985 177.5C503.485 177.5 508.735 171 519.235 157.75C535.985 136.5 541.235 129.75 579.735 101.5C581.235 113 590.735 113 591.735 113C596.985 113 596.985 110 596.985 109.25C596.985 108.5 596.485 108.25 595.235 108.25C592.985 108.25 588.985 108.25 588.985 101.75C588.985 97.75 590.485 96 591.735 94.5C601.985 88.25 603.235 84.5 603.235 83.25C603.235 81.75 600.985 81.25 599.485 81.25C589.735 81.25 585.485 85 580.485 95L558.985 110.75Z"
                fill="white"
              />
              <path
                d="M613.131 176H661.381C695.381 176 722.131 147.75 722.131 90C722.131 33 696.881 5 662.381 5H613.131V8.74999H616.881C625.381 8.74999 628.381 11.75 628.381 23.5V157.25C628.381 169 625.381 172.25 616.881 172.25H613.131V176ZM658.381 172.25C649.881 172.25 646.881 169.25 646.881 157.5V23.5C646.881 11.75 650.131 8.74999 658.381 8.74999H662.881C691.381 8.74999 701.881 37.5 701.881 91C701.881 143.5 689.631 172.25 662.381 172.25H658.381ZM714.453 176H751.203V172.25H747.703C740.703 172.25 736.953 168.25 736.953 159.75C736.953 153.5 738.953 145.25 741.453 135L745.453 120H790.953L797.203 143.25C799.703 152 800.953 158.5 800.953 163C800.703 168 796.953 172.25 789.703 172.25H784.453V176H836.203V172.25C827.953 172 822.953 168.5 819.203 154.5L777.453 1.5H773.203L733.453 144.5C728.453 162.5 724.453 171.5 714.453 172.25V176ZM746.453 116L768.453 34.25L789.953 116H746.453ZM882.182 179.5C911.432 179.5 934.682 142 934.682 90C934.682 38 911.182 1.5 882.432 1.5C853.432 1.5 829.932 38.25 829.932 91C829.932 143.5 853.432 179.5 882.182 179.5ZM882.432 176.5C856.932 176.5 850.432 136.25 850.432 90C850.432 43.75 856.432 4.49999 882.182 4.49999C907.682 4.49999 914.182 44.75 914.182 91C914.182 137.25 907.932 176.5 882.432 176.5Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        <video
          id="cover-video"
          ref="videoElement"
          class="h-full w-full object-cover bg-center z-10 relative bg-videoBg videoImage"
          autoplay
          playsinline
          muted
          loop
        />

        <!-- <div class="bottom-0 left-0 right-0 absolute pb-16 z-20">
          <div class="text-center text-7xl pb-4">
            <p class="font-serif">
              <router-link to="/" class="italic"> Overview, </router-link>
              <router-link to="/how-to-back"> How to Back, </router-link>
              <router-link to="/faqs"> FAQ, </router-link>
              <router-link to="/team"> Our Team </router-link>
            </p>
          </div>
        </div> -->
      </div>
      <div v-show="!overlay">
        <section
          v-if="introTitle"
          class="bg-creme flex items-center justify-center"
        >
          <div class="text-center pt-20 lg:pt-30 pb-10 lg:pb-16 px-5 lg:px-10">
            <h3
              class="text-3xl lg:text-7xl uppercase font-serif max-w-screen-lg mx-auto large-header-style"
              v-html="introTitle"
            />

            <div
              class="flex space-x-10 text-left mt-10 lg:mt-16 max-w-6xl mx-auto"
            >
              <div
                ref="contentfulWrapper"
                class="font-serif text-xl sm:text-lg contentful-wrapper overflow-x-hidden"
                v-html="introContent"
              />
            </div>
          </div>
        </section>
      </div>
      <div v-if="!overlay">
        <!-- <img src="@/assets/manor.jpg" class="w-full h-auto block" /> -->

        <section
          class="bg-creme flex items-center justify-center pt-6 pb-6 lg:pt-10 lg:pb-10"
        >
          <div class="max-w-5xl px-5 lg:px-10 text-center">
            <a
              href="https://instagram.com/poolsuitemanor"
              target="_blank"
              class="underline text-4xl lg:text-7xl font-serif"
            >
              Peruse <i class="italic">the mood</i>
            </a>
          </div>
        </section>

        <section
          v-observe-visibility="postcardVisible"
          class="bg-creme flex items-center justify-center py-10 lg:py-16 pt-4 lg:pt-0 overflow-x-hidden"
        >
          <div
            class="max-w-5x mx-auto w-11/12 md:w-2/3 z-50 relative group"
            style="padding-top: 50%"
            :class="`postcard-state-${postcardState}`"
          >
            <div
              class="absolute flex items-center justify-center inset-0 card-1"
            >
              <img
                src="@/assets/postcard-with-shadow.png"
                class=""
              >
            </div>
            <div
              class="absolute flex items-center justify-center inset-0 card-2"
            >
              <img
                src="@/assets/postcard-with-shadow-2.png"
                class=""
              >
            </div>
            <div
              class="absolute flex items-center justify-center inset-0 card-3"
            >
              <img
                src="@/assets/postcard-with-shadow-3.png"
                class=""
              >
            </div>
          </div>
        </section>

        <div
          v-show="imageAttached"
          id="image-container"
          ref="imageContainer"
          class="w-72 bg-cover bg-center pointer-events-none fixed z-50"
        >
          <span
            class="bg-white h-48 inset-0 absolute flex items-center justify-center"
          ><svg
            class="animate-spin h-5 w-5 text-green"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            />
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            /></svg></span>
          <img
            v-if="imageReferences[hoverText]"
            :src="imageReferences[hoverText].image"
            class="w-full h-48 object-cover block relative"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

import { ObserveVisibility } from "vue-observe-visibility";

import Hls from "hls.js";

import _ from "lodash";
export default {
  name: "OverviewPage",
  directives: {
    ObserveVisibility,
  },
  data() {
    return {
      imageAttached: false,
      introTitle: false,
      introContent: false,
      quote: false,
      quoteAuthor: false,
      hoverText: false,
      imageReferences: {},
      overlay: true,
      postcardState: 1,
      setInterval: false,
    };
  },
  computed: {},
  mounted() {
    this.initVideo();
    this.initContentful();
    this.videoLoaded();
    // this.updatePostcardState();
  },
  methods: {
    postcardVisible(state) {
      if (state) {
        if (this.setInterval) {
          return;
        }
        this.updatePostcardState();
      }
    },
    updatePostcardState() {
      this.setInterval = setInterval(() => {
        this.postcardState = this.postcardState + 1;
        if (this.postcardState == 4) {
          this.postcardState = 1;
          // clearInterval(this.setInterval);
        }
      }, 2000);
    },
    videoLoaded() {
      setTimeout(() => {
        this.overlay = false;
        document.getElementById("overlay").style.opacity = "0";
        document.getElementById("overlay").style.visibility = "hidden";
      }, 200);
    },
    initVideo() {
      const videoSrc =
        "https://videodelivery.net/8194cb21336d1f7b318b743934f3e549/manifest/video.m3u8";

      const videoEl = this.$refs.videoElement;

      if (Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(videoSrc);
        hls.attachMedia(videoEl);
        hls.audioTrack = false;
      } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
        videoEl.src = videoSrc;
        videoEl.play();
      }
    },
    initContentful() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        // This is the space ID. A space is like a project folder in Contentful terms
        space: "hsst7dmi6ghe",
        // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
        accessToken: "452OGQVYT021J2XrtM7IZHpLfuN58MpB8pTqKXOwXD0",
      });
      // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
      client
        .getEntries({
          limit: 1000,
          "sys.contentType.sys.id[in]": "manordaoIntro,manordaoImages",
        })
        .then((response) => {
          if (this.introTitle) {
            return;
          }
          response.items.forEach((item) => {
            if (item.fields.quote) {
              const onlyContentNeeded = item.fields;
              this.introTitle = onlyContentNeeded.title;
              this.introContent = documentToHtmlString(onlyContentNeeded.intro);
              this.quote = onlyContentNeeded.quote;
              this.quoteAuthor = onlyContentNeeded.quoteAuthor;
            } else {
              let thisImage = item.fields.image.fields;
              let imageObject = {
                title: thisImage.title,
                image: thisImage.file.url,
              };
              this.imageReferences[imageObject.title] = imageObject;
            }
          });
          this.addHoverEventListeners();
        })
        .catch((err) => console.log(err));
    },
    addHoverEventListeners() {
      setTimeout(() => {
        let links = this.$refs.contentfulWrapper.getElementsByTagName("a");
        _.forEach(links, (link) => {
          link.addEventListener("mouseover", this.showImage);
          link.addEventListener("mouseleave", this.hideImage);

          link.addEventListener("touchend", this.hideImage);
          link.addEventListener("touchcancel", this.hideImage);

          link.addEventListener("click", (event) => {
            this.showImage(event);
            event.preventDefault();
          });
        });

        document.body.addEventListener("click", (event) => {
          if (event.target.tagName == "A") {
            return;
          }
          this.hideImage();
        });
      }, 700);
    },
    followMouse(event) {
      this.$refs.imageContainer.style.left = event.x + "px";
      this.$refs.imageContainer.style.top = event.y + "px";
    },
    showImage(event) {
      console.log("showing image");
      this.hoverText = event.target.innerHTML;
      this.imageAttached = true;
      this.followMouse(event);
      document.addEventListener("pointermove", this.followMouse);
    },
    hideImage() {
      this.imageAttached = false;
      document.removeEventListener("pointermove", this.followMouse);
    },
  },
};
</script>
